import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Sidebar from '../../components/feature/Sidebar';
import Breadcrumb from '../../components/feature/Breadcrumb';

const TinGamePage = () => {
  const breadcrumbItems = [
    { label: 'Trang chủ', href: '/' },
    { label: 'Tin Game' }
  ];

  const newsArticles = [
    {
      id: 7,
      title: 'Hướng Dẫn Nạp Tiền Iwin68 Nhanh – Bảo Mật – Không Lỗi 2025',
      slug: 'huong-dan-nap-tien-iwin68-nhanh-bao-mat-khong-loi-2025',
      excerpt: 'Trong thế giới cá cược trực tuyến, yếu tố nhanh – chuẩn – an toàn luôn là kim chỉ nam của mọi giao dịch. Hướng dẫn chi tiết cách nạp tiền iwin68 siêu tốc, không lỗi và bảo mật tuyệt đối.',
      category: 'Hướng Dẫn',
      image: 'https://public.readdy.ai/ai/img_res/cb7b5289d79d32852800b4140b1463b9.jpg',
      date: '2025-01-16',
      views: '2.5M'
    },
    {
      id: 1,
      title: 'Cộng Đồng Game Việt Nam Phát Triển Mạnh Mẽ Năm 2025',
      slug: 'cong-dong-game-viet-nam-phat-trien-manh-me-nam-2025',
      excerpt: 'Thị trường game Việt Nam đang chứng kiến sự tăng trưởng vượt bậc với hàng triệu game thủ tham gia và nhiều giải đấu esports quy mô lớn được tổ chức.',
      category: 'Cộng Đồng',
      image: 'https://readdy.ai/api/search-image?query=vietnamese%20gaming%20community%20event%2C%20large%20crowd%20of%20gamers%2C%20esports%20arena%2C%20exciting%20atmosphere%2C%20modern%20venue%2C%20vibrant%20lighting&width=800&height=600&seq=tingame-1&orientation=landscape',
      date: '2025-01-15',
      views: '2.1M'
    },
    {
      id: 2,
      title: 'VCS 2025: Mùa Giải Hứa Hẹn Nhiều Bất Ngờ',
      slug: 'vcs-2025-mua-giai-hua-hen-nhieu-bat-ngo',
      excerpt: 'Giải đấu Liên Minh Huyền Thoại Việt Nam mùa xuân 2025 khởi tranh với nhiều đội tuyển mạnh và những gương mặt tài năng mới.',
      category: 'Esports',
      image: 'https://readdy.ai/api/search-image?query=league%20of%20legends%20vcs%20tournament%20stage%2C%20professional%20esports%20setup%2C%20team%20competing%2C%20dramatic%20lighting%2C%20modern%20arena&width=800&height=600&seq=tingame-2&orientation=landscape',
      date: '2025-01-14',
      views: '1.8M'
    },
    {
      id: 3,
      title: 'Top 5 Game Mobile Được Yêu Thích Nhất Tại Việt Nam',
      slug: 'top-5-game-mobile-duoc-yeu-thich-nhat-tai-viet-nam',
      excerpt: 'Khảo sát mới nhất về thị hiếu game mobile của người chơi Việt, với những cái tên quen thuộc và cả những bất ngờ thú vị.',
      category: 'Reviews',
      image: 'https://readdy.ai/api/search-image?query=mobile%20gaming%20on%20smartphone%2C%20hands%20holding%20phone%20playing%20game%2C%20colorful%20game%20interface%2C%20modern%20lifestyle%2C%20engaging%20gameplay&width=800&height=600&seq=tingame-3&orientation=landscape',
      date: '2025-01-13',
      views: '1.5M'
    },
    {
      id: 4,
      title: 'Xu Hướng Esports Việt Nam 2025: Cơ Hội Và Thách Thức',
      slug: 'xu-huong-esports-viet-nam-2025-co-hoi-va-thach-thuc',
      excerpt: 'Phân tích về tình hình phát triển của esports Việt Nam, những cơ hội đột phá và thách thức cần vượt qua trong năm 2025.',
      category: 'Esports',
      image: 'https://readdy.ai/api/search-image?query=esports%20industry%20analysis%2C%20professional%20gaming%20tournament%2C%20modern%20arena%2C%20competitive%20gaming%20scene%2C%20futuristic%20atmosphere&width=800&height=600&seq=tingame-4&orientation=landscape',
      date: '2025-01-12',
      views: '1.3M'
    },
    {
      id: 5,
      title: 'Game Thủ Việt Tỏa Sáng Tại Các Giải Đấu Quốc Tế',
      slug: 'game-thu-viet-toa-sang-tai-cac-giai-dau-quoc-te',
      excerpt: 'Những thành tích đáng tự hào của game thủ Việt Nam tại các giải đấu quốc tế, khẳng định vị thế trên bản đồ esports thế giới.',
      category: 'Esports',
      image: 'https://readdy.ai/api/search-image?query=vietnamese%20esports%20players%20winning%20international%20tournament%2C%20trophy%20celebration%2C%20national%20flag%2C%20proud%20moment%2C%20professional%20photography&width=800&height=600&seq=tingame-5&orientation=landscape',
      date: '2025-01-11',
      views: '1.7M'
    },
    {
      id: 6,
      title: 'Streaming Game: Nghề Mới Hấp Dẫn Giới Trẻ Việt Nam',
      slug: 'streaming-game-nghe-moi-hap-dan-gioi-tre-viet-nam',
      excerpt: 'Xu hướng streaming game đang trở thành nghề nghiệp hấp dẫn với thu nhập cao, thu hút nhiều bạn trẻ Việt Nam theo đuổi.',
      category: 'Cộng Đồng',
      image: 'https://readdy.ai/api/search-image?query=vietnamese%20game%20streamer%20at%20work%2C%20professional%20streaming%20setup%2C%20multiple%20monitors%2C%20engaging%20with%20audience%2C%20modern%20studio&width=800&height=600&seq=tingame-6&orientation=landscape',
      date: '2025-01-10',
      views: '1.4M'
    }
  ];

  return (
    <>
      <title>Tin Game - Tin tức, cộng đồng và esports Việt Nam | Gametv.asia</title>
      <meta name="description" content="Cập nhật tin tức game mới nhất, thông tin cộng đồng game thủ và các giải đấu esports tại Việt Nam. Tin game 24/7." />
      <meta name="keywords" content="tin game, tin tức game, esports việt nam, cộng đồng game, game thủ việt nam" />
      <link rel="canonical" href="https://gametv.asia/tin-game" />
      
      <meta property="og:title" content="Tin Game - Tin tức và esports Việt Nam | Gametv.asia" />
      <meta property="og:description" content="Cập nhật tin tức game mới nhất, thông tin cộng đồng game thủ và các giải đấu esports tại Việt Nam." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://gametv.asia/tin-game" />

      <div className="min-h-screen bg-dark-bg">
        <Header />

        <main className="pt-24 pb-20">
          <div className="max-w-[1600px] mx-auto px-6">
            <Breadcrumb items={breadcrumbItems} />

            {/* Page Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="mb-12 mt-8"
            >
              <h1 className="font-exo font-black text-4xl md:text-5xl text-white mb-4">
                TIN <span className="bg-gradient-gaming bg-clip-text text-transparent">GAME</span>
              </h1>
              <p className="text-gray-400 text-lg">
                Cập nhật tin tức game, esports và cộng đồng game thủ Việt Nam
              </p>
            </motion.div>

            <div className="flex gap-8">
              {/* News Grid */}
              <div className="flex-1">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {newsArticles.map((article, index) => (
                    <motion.article
                      key={article.id}
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.1 }}
                      className="group bg-dark-card rounded-2xl overflow-hidden border border-gray-800 hover:border-accent-cyan transition-all duration-300"
                    >
                      <Link to={`/bai-viet/${article.slug}`}>
                        {/* Image */}
                        <div className="relative h-56 overflow-hidden">
                          <img
                            src={article.image}
                            alt={article.title}
                            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                            loading="lazy"
                          />
                          <div className="absolute top-4 left-4">
                            <span className="px-3 py-1 bg-accent-purple/90 text-white text-xs font-bold rounded-full">
                              {article.category}
                            </span>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="p-6">
                          <h2 className="font-exo font-bold text-xl text-white mb-3 group-hover:text-accent-cyan transition-colors line-clamp-2">
                            {article.title}
                          </h2>
                          <p className="text-gray-400 text-sm mb-4 line-clamp-2">
                            {article.excerpt}
                          </p>

                          {/* Meta */}
                          <div className="flex items-center justify-between text-xs text-gray-500">
                            <span>{article.date}</span>
                            <span>{article.views} lượt xem</span>
                          </div>
                        </div>
                      </Link>
                    </motion.article>
                  ))}
                </div>
              </div>

              {/* Sidebar */}
              <div className="hidden xl:block">
                <div className="sticky top-24">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default TinGamePage;